import React, { useContext } from 'react';
import Countdown from "react-countdown";
import { AppContext } from '../../../../../AppContext';
import { getMediaUrl } from '../../../../../utils/utils';
import StandartIcon from '../../../../../icons/standart.svg';
import PremiumIcon from '../../../../../icons/premium.svg';

const icons = {
  Standard: (
    <>
      <img src={getMediaUrl(StandartIcon)} alt="Standard" />
      <img src={getMediaUrl(PremiumIcon)} alt="Premium" />
    </>
  ),
  Premium: <img src={getMediaUrl(PremiumIcon)} alt="Premium" />,
  Free: <span className="access__label">Free</span>
};

export function Access({ row }) {
  const { user } = useContext(AppContext);
  const access = row.access_lbl;
  const freemium = row.freemium;
  const currentDate = new Date();
  const isNeedCountdown = user.type !== 'pcp' && freemium?.activate && currentDate > new Date(freemium.freemium_period_start) && currentDate < new Date(freemium.freemium_period_end);

  return (
    <div className="access">
      {isNeedCountdown
        ? <Countdown className="access__label access__countdown" date={new Date(freemium.freemium_period_end)} />
        : icons[access]
      }
    </div>
  );
}
